module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('app-page-header'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.contratos,
      "label": "Curso",
      "no-data-text": "Nenhum curso encontrado",
      "clearable": "",
      "item-value": "id",
      "item-text": "descricao"
    },
    on: {
      "input": _vm.selecionaContrato
    },
    model: {
      value: (_vm.contrato),
      callback: function($$v) {
        _vm.contrato = $$v
      },
      expression: "contrato"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.periodosVazio) ? _c('empty-list', {
    attrs: {
      "title": "Selecione o Curso",
      "description": "As suas disciplinas serão mostradas conforme o contrato selecionado"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.periodosVazio) ? _c('div', [_c('h3', {
    staticClass: "page-content-title"
  }, [_vm._v("Disciplinas")]), _vm._v(" "), _c('div', {
    staticClass: "responsive-table"
  }, [_c('table', {
    staticClass: "v-table table-disciplinas-cursadas"
  }, _vm._l((_vm.periodos), function(periodo) {
    return _c('tbody', [_c('tr', {
      staticClass: "header-table"
    }, [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("Período: "), _c('strong', [_vm._v(_vm._s(periodo.descricao))])])]), _vm._v(" "), _c('tr', {
      staticClass: "subheader-table"
    }, [_c('td', [_vm._v("Disciplina")]), _vm._v(" "), _c('td', [_vm._v("Situação")]), _vm._v(" "), _c('td', [_vm._v("Turno")]), _vm._v(" "), _c('td', [_vm._v("Frequência")]), _vm._v(" "), (_vm.posGraduacao) ? _c('td', [_vm._v("Conceito")]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('td', [_vm._v("Média Final")]) : _vm._e()]), _vm._v(" "), _vm._l((periodo.matriculas), function(matricula) {
      return (matricula.ref_tipo_atividade !== 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(matricula.disciplina))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(matricula.estado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(matricula.turno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(matricula.frequencias[0].frequencia) + " %")]), _vm._v(" "), (_vm.posGraduacao) ? _c('td', [_vm._v(_vm._s(matricula.conceito1))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && matricula.media_final > 0) ? _c('td', [_vm._v(_vm._s(matricula.media_final))]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && matricula.media_final == 0 && matricula.estado == 'Aprovado') ? _c('td', [_vm._v(" - ")]) : _vm._e()]) : _vm._e()
    })], 2)
  }), 0)]), _vm._v(" "), (_vm.periodosComplementares) ? _c('div', [_c('h3', {
    staticClass: "page-content-title"
  }, [_vm._v("Atividades Complementares")]), _vm._v(" "), _c('div', {
    staticClass: "responsive-table"
  }, [_c('table', {
    staticClass: "v-table table-disciplinas-cursadas"
  }, [_c('tbody', [_c('tr', {
    staticClass: "subheader-table"
  }, [_c('td', [_vm._v("Disciplina")]), _vm._v(" "), (!_vm.posGraduacao) ? _c('td', [_vm._v("Carga Horária Cadastrada")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.periodosComplementares), function(periodo) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(periodo.disciplina))]), _vm._v(" "), (!_vm.posGraduacao) ? _c('td', [_vm._v(_vm._s(periodo.total))]) : _vm._e()])
  })], 2)])])]) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-504aca25!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/academico/components/DisciplinasCursadas.vue
// module id = 541
// module chunks = 2